import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Card, CardContent } from '../ui/card';
import { Home, Building2, TrendingUp, Users, Building, MapPin } from 'lucide-react';
import { services } from '../../data/mockData';
import { useNavigate } from 'react-router-dom';

const iconMap = {
  Home,
  Building2,
  TrendingUp,
  Users,
  Building,
  MapPin
};

const ServicesSection = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t({ en: 'Everything You Need in One Place', ar: 'كل ما تحتاجه في مكان واحد' })}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t({
              en: 'A comprehensive platform for all your Dubai real estate investment needs',
              ar: 'منصة شاملة لجميع احتياجاتك الاستثمارية في عقارات دبي'
            })}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer overflow-hidden border-0"
                onClick={() => navigate('/services')}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={t(service.title)}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold inline-block">
                      {service.yield}
                    </div>
                  </div>
                </div>
                <CardContent className="p-6">
                  <div className="flex items-center mb-3">
                    {Icon && (
                      <div className="w-12 h-12 bg-[#C5A038]/20 rounded-lg flex items-center justify-center mr-4 group-hover:bg-[#C5A038] transition-colors duration-300">
                        <Icon className="w-6 h-6 text-[#C5A038] group-hover:text-white transition-colors duration-300" />
                      </div>
                    )}
                    <h3 className="text-xl font-bold text-gray-900 group-hover:text-[#12532c] transition-colors duration-300">
                      {t(service.title)}
                    </h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed">{t(service.description)}</p>
                  <div className="mt-4 text-[#12532c] font-semibold group-hover:translate-x-2 transition-transform duration-300 inline-flex items-center">
                    {t({ en: 'Explore Now', ar: 'استكشف الآن' })} →
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
